import { i18next } from '@frontend/i18n';

export const FeatureCancellationTermsList = [
  i18next.t(
    'By signing up for this feature, your account will be charged immediately at a prorated rate based on the number of days remaining in your current billing cycle.',
    { ns: 'subscription>>legal-terms' }
  ),
  i18next.t(
    'If you choose to cancel the feature, it will be removed from your upcoming billing cycle. Access to the feature will be revoked immediately upon cancellation.',
    { ns: 'subscription>>legal-terms' }
  ),
  i18next.t(
    'For customers on annual billing plans, a prorated credit for the remaining unused portion of the feature will be applied to your account and reflected on your next invoice.',
    { ns: 'subscription>>legal-terms' }
  ),
  i18next.t('To cancel, please return to this page and follow cancellation flow', { ns: 'subscription>>legal-terms' }),
];
